import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Terms = () => {
  return (
    <>
      <Header />
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="space-y-8">
          <div className="text-sm text-gray-600">
            Last Updated: [Insert Date]
          </div>

          <section className="space-y-6">
            <h1 className="text-3xl font-bold text-gray-900">Terms of Service</h1>
            
            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Agreement to Terms</h2>
              <p className="text-gray-700 leading-relaxed">
                By accessing or using ArcAdvantage.ai's website at arcadvantage.ai, you agree to be bound by these Terms of Service. If you disagree with any part of these terms, you may not access our services.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Use License</h2>
              <p className="text-gray-700 leading-relaxed">
                Permission is granted to temporarily access our materials for personal, non-commercial use only. This is the grant of a license, not a transfer of title. Under this license, you may not:
              </p>
              <ul className="list-disc pl-6 mt-2 space-y-2 text-gray-700">
                <li>Modify or copy the materials</li>
                <li>Use the materials for any commercial purpose</li>
                <li>Transfer the materials to another person</li>
                <li>Attempt to reverse engineer any software contained on our website</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">3. User Account</h2>
              <p className="text-gray-700 leading-relaxed">
                To access certain features, you may need to create an account. You are responsible for maintaining the confidentiality of your account information and for all activities under your account.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Service Modifications</h2>
              <p className="text-gray-700 leading-relaxed">
                We reserve the right to modify or discontinue our service at any time, with or without notice. We shall not be liable to you or any third party for any modification, suspension, or discontinuance of the service.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Limitation of Liability</h2>
              <p className="text-gray-700 leading-relaxed">
                Our materials are provided on an 'as is' basis. We make no warranties, expressed or implied, and hereby disclaim all warranties, including without limitation, implied warranties of merchantability and fitness for a particular purpose.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Governing Law</h2>
              <p className="text-gray-700 leading-relaxed">
                These terms shall be governed by and construed in accordance with the laws of North Carolina, without regard to its conflict of law provisions.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Changes to Terms</h2>
              <p className="text-gray-700 leading-relaxed">
                We reserve the right to modify these terms at any time. We will notify users of any changes by updating the date at the top of these terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Contact Information</h2>
              <div className="space-y-1 text-gray-700">
                <p>Questions about the Terms of Service should be sent to:</p>
                <div className="mt-4">
                  <p>support@arcadvantage.ai</p>
                </div>
              </div>
            </section>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Terms;